import React, { useEffect } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { LuImage, LuPenTool } from "react-icons/lu";
import { MdOutlineFileUpload } from "react-icons/md";
import { ImTree } from "react-icons/im";
import { BsPersonCheck } from "react-icons/bs";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";

const TabManager = ({ activeTab, handleSelectTab, tabs, tabPageName }) => {
  const renderLiId = (_id) => {
    switch (tabPageName) {
      case "EquipmentDetailOverview":
        if (_id === 1) {
          return "details";
        } else if (_id === 2) {
          return "orders";
        } else if (_id === 3) {
          return "photo";
        } else if (_id === 4) {
          return "archivs";
        } else if (_id === 5) {
          return "reparation";
        } else if (_id === 6) {
          return "children";
        } else if (_id === 7) {
          return "responsibilities";
        } else if (_id === 8) {
          return "Tickets";
        }
      case "EmailNotification":
        if (_id === 1) {
          return "emailDistributionGroup";
        } else if (_id === 2) {
          return "emailScheduler";
        } else if (_id === 3) {
          return "scheduledEmails";
        }
      default:
    }
  };

  const renderIcon = (_id) => {
    switch (tabPageName) {
      case "EquipmentDetailOverview":
        if (_id === 1) {
          return <InfoOutlinedIcon sx={{ fontSize: 18 }} />;
        } else if (_id === 2) {
          return <DescriptionOutlinedIcon sx={{ fontSize: 18 }} />;
        } else if (_id === 3) {
          return <LuImage size={16} />;
        } else if (_id === 4) {
          return <MdOutlineFileUpload size={18} />;
        } else if (_id === 5) {
          return <LuPenTool size={18} />;
        } else if (_id === 6) {
          return <ImTree size={16} />;
        } else if (_id === 7) {
          return <BsPersonCheck size={18} />;
        } else if (_id === 8) {
          return <ConfirmationNumberOutlinedIcon sx={{ fontSize: 18 }} />;
        }
      case "EmailNotification":
    }
  };
  return (
    <ul className="nav nav-tabs nav-justified equipDetailsNav">
      {tabs.map((item) => {
        return (
          <li
            id={renderLiId(item.id)}
            key={item.id}
            className="nav-item details"
            onClick={() => {
              handleSelectTab(item.id);
            }}
          >
            <a
              className={activeTab === item.id ? "nav-link active" : "nav-link"}
            >
              {renderIcon(item.id)} {item.title}
            </a>
          </li>
        );
      })}
    </ul>
  );
};
export default TabManager;
{
  /* <li
            key={item.id}
            className={
              activeTab === item.id ? 'active' : ''
              //   ? 'tab-list-item tab-list-active'
              //   : 'tab-list-item'
            }
          >
            <a
              onClick={() => {
                handleSelectTab(item.id);
              }}
              style={{ decoration: 'none' }}
            >
              {' '}
              {item.title}
            </a>
          </li> */
}
